import { alpha, Box, Button, Container, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useClerk, useUser } from '@clerk/clerk-react';

const LOGO = 32;
const LOGO_RADIUS = 8;

export default function SiteHeaderAccount() {
  const { t } = useTranslation();
  const { user, isLoaded } = useUser();
  const { signOut } = useClerk();
  const email = user?.primaryEmailAddress?.emailAddress || '';

  const displayName =
    user?.firstName ||
    email ||
    user?.username ||
    t('account.title');

  return (
    <Box
      component="header"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1100,
        py: 1,
        backgroundColor: alpha('#090b0d', 0.52),
        backdropFilter: 'blur(18px) saturate(140%)',
        WebkitBackdropFilter: 'blur(18px) saturate(140%)',
        borderBottom: `1px solid ${alpha('#fff', 0.08)}`,
        boxShadow: `0 12px 40px ${alpha('#000', 0.16)}`,
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          pointerEvents: 'none',
          background:
            'linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0.015))',
        },
        color: 'text.primary',
      }}
    >
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          gap={2}
          height={40}
        >
          <Box display="flex" alignItems="center" gap={2} minWidth={0} flex="1 1 auto">
            <Box
              component={RouterLink}
              to="/"
              aria-label={t('nav.back')}
              sx={{
                flexShrink: 0,
                display: 'block',
                width: LOGO,
                height: LOGO,
                borderRadius: `${LOGO_RADIUS}px`,
                overflow: 'hidden',
                bgcolor: alpha('#000000', 0.8),
                lineHeight: 0,
                textDecoration: 'none',
                color: 'inherit',
                boxShadow: `0 8px 24px ${alpha('#000', 0.22)}`,
              }}
            >
              <img src="/lett-logo.webp" alt="" width={LOGO} height={LOGO} />
            </Box>
            {isLoaded && (
              <Typography
                component="h6"
                variant="h6"
                sx={{
                  fontWeight: 700,
                  minWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {t('account.greeting', { name: displayName })}
              </Typography>
            )}
          </Box>
          <Box display="flex" alignItems="center" gap={3} flexShrink={0}>
            <Button
              variant="text"
              color="inherit"
              onClick={() =>
                signOut({ redirectUrl: `${window.location.origin}/` })
              }
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 999,
                px: 1.25,
                bgcolor: alpha('#fff', 0.04),
                '&:hover': {
                  bgcolor: alpha('#fff', 0.08),
                },
              }}
            >
              {t('account.logout')}
            </Button>
          </Box>
        </Box>
        {email && (
          <Box ml={6}>
            <Typography
              component="div"
              variant="body2"
              color="text.secondary"
              sx={{
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {email}
            </Typography>
          </Box>
        )}
      </Container>
    </Box>
  );
}
